import React, { useEffect } from "react";
import { ApprovalListType } from "../../../../redux/hrms/hrmsTypes";
import CustomizedAvatar from "../../../commons/CircularAvatar/CustomizedAvatar";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { AddIconColor } from "../../../../assets/images";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";

type AppProps = {
  data: ApprovalListType[] | [];
  sendApprovalsModal: boolean;
  setSendApprovalsModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const ApprovalsDeatils = ({
  data,
  sendApprovalsModal,
  setSendApprovalsModal,
}: AppProps) => {
  const [
    isSendRecruitmentApprovalPresent,
    setIsSendRecruitmentApprovalPresent,
  ] = useMenuCheck("");

  useEffect(() => {
    setIsSendRecruitmentApprovalPresent("Send Recruitment Approval", "menu");
  }, []);

  return (
    <>
      <div className="mb-2" style={{ marginTop: "29px" }}>
        <h5
          style={{
            marginBottom: "10px",
            fontSize: "15px",
            fontWeight: "600",
          }}
        >
          Candidate Status
        </h5>
      </div>
      <div className="row">
        {data?.length > 0
          ? data?.map((el: ApprovalListType, index: number) => {
              return (
                <div className="col-md-12 mb-3">
                  <div className="p-2" style={{ border: "1px solid #bfcbe1" }}>
                    <div className="d-flex" style={{ gap: "1%" }}>
                      <div style={{ width: "18%" }}>
                        <div style={{ color: "#6e7491" }}>
                          Level 0{index + 1}
                        </div>
                        <div
                          style={{
                            width: "fit-content",
                            borderRadius: "16px",
                            color: el?.status === 3 ? "#82b01f" : "",
                            background: el?.status === 3 ? "#e7f0d4" : "",
                            // whiteSpace: "nowrap",
                          }}
                          className={
                            el?.status === 1
                              ? "phoneScreening mt-1"
                              : el?.status === 2
                              ? "rejected mt-1"
                              : "credit mt-1"
                          }
                        >
                          {el?.status === 1
                            ? "Pending Approval"
                            : el?.status === 2
                            ? "Candidate Rejected"
                            : "Candidate Approved"}
                        </div>
                      </div>
                      <div style={{ width: "18%" }}>
                        <div style={{ color: "#6e7491" }}>Approved By</div>

                        <div
                          className="d-flex align-items-center mt-1"
                          style={{ gap: "3%" }}
                        >
                          <div>
                            <CustomizedAvatar
                              name={`${
                                el?.approved_by?.first_name +
                                " " +
                                el?.approved_by?.last_name
                              }`}
                              image={el?.approved_by?.profile_pic?.file_url}
                              style={{ width: "42px", fontSize: "18px" }}
                            />
                          </div>
                          <div>
                            <p
                              className="mb-0"
                              style={{
                                fontSize: "15px",
                                fontWeight: 500,

                                cursor: "pointer",
                              }}
                            >
                              {el?.approved_by?.first_name +
                                " " +
                                el?.approved_by?.last_name}{" "}
                            </p>
                            <p
                              className="mt-0 mb-1"
                              style={{ color: "#6e7491" }}
                            >{`${el?.approved_by?.job_title} `}</p>
                            <div
                              style={{
                                color: "#28a745",
                                display: "flex",
                                alignItems: "center",
                                fontWeight: 500,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div style={{ width: "60%" }}>
                        <div style={{ color: "#6e7491" }}>Comment</div>
                        <div>
                          {el?.comment?.length > 250 ? (
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view-open-item">
                                  {el?.comment}
                                </Tooltip>
                              }
                            >
                              <div>
                                {el?.comment
                                  ? el?.comment?.substr(0, 250) +
                                    (el?.comment && el?.comment?.length > 250
                                      ? "..."
                                      : "")
                                  : "NA"}
                              </div>
                            </OverlayTrigger>
                          ) : (
                            <>{el?.comment ? el?.comment : "NA"}</>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          : ""}
      </div>
      {isSendRecruitmentApprovalPresent && (
        <button
          className="btn btn-outline-secondary mt-3"
          onClick={() => {
            setSendApprovalsModal(!sendApprovalsModal);
          }}
          disabled={
            (data?.length > 0 && data[data?.length - 1]?.status === 1) ||
            data?.length === 4
          }
          style={{
            color: "#dd4433",
            border: "1px solid #dd4433",
            fontSize: "13px",
          }}
        >
          <img src={AddIconColor} alt="" />
          Send for Approval
        </button>
      )}
    </>
  );
};

export default ApprovalsDeatils;
